import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'

export default () => (
  <StaticQuery
    query={graphql`
        {
          prismic {
            allTools(sortBy: name_DESC) {
              edges {
                node {
                  name
                  logo
                  description
                  _meta{
                    type
                    uid
                  }
                }
              }
            }
          }
        }
        `}
    render={data => (
      <div className="grid-child with-content">
        <div className="content-intro">
          <h2>TOOLS.</h2>
          <h4>Outlines on the tools I used, brief summaries on my progress with them, and resulting projects. Throughout the timeline I reference these pieces of my new and improved web-development tech stack.</h4>
          <p>← Scroll Left</p>
        </div>
        <div className="card-parent home">
          {data.prismic.allTools.edges.map(({ node: tool }, i) => (
            <Link to={linkResolver(tool._meta)} key={i} className="no-decoration">
              <div className="card w-inline-block">
                <div className="card-label">
                  <h4 className="card-title">{tool.name[0].text}</h4>
                  <div>{tool.description[0].text}</div>
                </div>
                <div className="card-image">
                  <img src={tool.logo.url} className="tool-logo" alt="tool" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    )}
  />
)